import type { State } from '../store/types';
import { singleUserVersion } from '../store/selectors';
import { getPageGroups } from '../store/selectors/pages/getPageGroups';
import { isPageActive } from '../store/selectors/features/isPageActive';
import { getFeatureStates } from '../store/selectors/features/getFeatureStates';

export function pagesAsSelectTagOptions(state: State, allPages: boolean = false) {
  const pageGroups = getPageGroups(state);
  const themePages = pageGroups.find((group) => {
    return group.code === 'themePages';
  });
  if (themePages) {
    return themePages.pages
      .filter((page) => {
        return isPageActive(page.pageId, getFeatureStates(state), singleUserVersion(state)) || allPages;
      })
      .map((page) => {
        return { value: '' + page.pageId, text: page.name };
      });
  }
  return [];
}
